import { inject, runInInjectionContext, Injector } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GlobalService } from '@core/services';
import { Auth, signInWithCustomToken, User } from '@angular/fire/auth';
import { LoaderService } from '@core/components/loader/loader.service';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

export const firebaseConfigResolver: ResolveFn<boolean> = () => {
  return inject(GlobalService)
    .getConfigurations()
    .pipe(map(config => !!config.fireBase.apiKey));
};

export const firebaseAuthResolver: ResolveFn<User> = async () => {
  const injector = inject(Injector);
  const fireAuth = inject(Auth);
  if (fireAuth.currentUser) return fireAuth.currentUser;
  const globalService = inject(GlobalService);
  const loaderService = inject(LoaderService);
  const customToken = await firstValueFrom(
    globalService.getFirebaseAuthToken()
  );
  loaderService.show();
  const userCredential = await runInInjectionContext(injector, () =>
    signInWithCustomToken(fireAuth, customToken.customToken.result)
  );
  loaderService.hide();
  return userCredential.user;
};
